import React from 'react';

const Header = () => {
  const logos = [
    {
      name: 'Nifty Travel Magnet',
      url: 'https://customer-assets.emergentagent.com/job_sequence-builder-2/artifacts/oz427wzz_Nifty%20Travel%20Magnet.png',
      alt: 'Nifty Travel Magnet'
    },
    {
      name: 'Manovah Eco Safaris',
      url: 'https://customer-assets.emergentagent.com/job_sequence-builder-2/artifacts/odgttarh_ManovahEcoSafaris.png',
      alt: 'Manovah Eco Safaris'
    },
    {
      name: 'Uganda Insider',
      url: 'https://customer-assets.emergentagent.com/job_sequence-builder-2/artifacts/0veu2pl1_Uganda%20Insider_NoBG.png',
      alt: 'Uganda Insider'
    }
  ];

  return (
    <header style={{backgroundColor: 'rgb(66, 120, 156)'}} className="text-white shadow-lg">
      <div className="container mx-auto px-4 py-6">
        <div className="flex items-center justify-between flex-wrap gap-4">
          {/* Logos */}
          <div className="flex items-center gap-4 md:gap-6">
            {logos.map((logo, index) => (
              <div 
                key={index}
                className="w-16 h-16 md:w-20 md:h-20 bg-white rounded-lg flex items-center justify-center p-2 shadow-md hover:shadow-lg transition-shadow"
                data-testid={`logo-${index + 1}`}
              >
                <img 
                  src={logo.url} 
                  alt={logo.alt}
                  className="w-full h-full object-contain"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
          
          {/* Title */}
          <div className="flex-1 text-center">
            <h1 className="text-3xl md:text-4xl font-bold" style={{color: '#D4A948'}}>Uganda Insider</h1>
            <p className="text-sm mt-1 opacity-90">Your Gateway to Uganda</p>
          </div>

          {/* Spacer for layout balance */}
          <div className="hidden md:block w-20 lg:w-64"></div>
        </div>
      </div>
    </header>
  );
};

export default Header;